import filterMessageView from './filterMessageComponent.html';
import './filterMessageComponent.css';

export function filterMessageComponent() {
	return {
		bindings: {
			search: '=',
			filteredMessage: '@',
			classifications: '<?',
			tags: '<?',
			categories: '<?',
			users: '<?',
			domains: '<?',
			immutableFields: '<?',
			filterChangeCallback: '<?',
		},
		controllerAs: 'vm',
		controller: filterMessageComponentCtrl,
		template: filterMessageView,
	};
}

class filterMessageComponentCtrl {
	constructor($scope, FilterMessage) {
		'ngInject';
		this.FilterMessage = FilterMessage;
		// re-render filter text every time we change search
		// or search is changed from the outside
		$scope.$watch('vm.search', () => this.processFilters(), true);
	}

	$onChanges(changes) {
		this.processFilters();
	}

	reset() {
		// remove all filters in reverse order
		// so that array splicing will not affect
		// subsequent filters
		this.getRemovableFilters()
			.reverse()
			.forEach(f => f.onRemove(this.search));
		if (this.filterChangeCallback) {
			this.filterChangeCallback(this.filters);
		}
	}

	getRemovableFilters() {
		return this.filters.filter(f => f.onRemove);
	}

	runOption(filter) {
		if (filter.onOption) {
			filter.onOption(this.search);
		}
	}

	remove(filter) {
		if (filter.onRemove) {
			filter.onRemove(this.search);
			if (this.filterChangeCallback) {
				this.filterChangeCallback(this.filters);
			}
		}
	}

	processFilters() {
		const oldFilters = JSON.stringify(this.filters);
		this.filters = this.FilterMessage.asObject(this);
		if (oldFilters == JSON.stringify(this.filters)) {
			return;
		}
		if (this.filterChangeCallback) {
			this.filterChangeCallback(this.filters);
		}
	}

	canReset() {
		return this.getRemovableFilters().length > 0;
	}
}
